import React from 'react';
import KeyHandler from './KeyHandler';

const injectKeyHandler = keys => WrappedComponent => {
    return class KeyHandlingWrapper extends React.PureComponent {
        render() {
            return (
                <KeyHandler keys={keys}>
                    <WrappedComponent {...this.props} />
                </KeyHandler>
            );
        }
    };
};

export default injectKeyHandler;
